import styled from 'styled-components';
import DoubleBuildingIconSvg from '../assets/DoubleBuildingIcon.svg';

const DoubleBuildingIcon = styled(
  DoubleBuildingIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DoubleBuildingIcon;
